import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
    selector: 'tt-product-move-choices',
    templateUrl: './product-move-choices.component.html',
    styleUrls: ['./product-move-choices.component.css'],
    standalone: false
})
export class ProductMoveChoicesComponent implements OnInit {
    prodId;

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadSetting() {
        if (!!this.prodId) {
            this.setting = (await this.datatask.Post(2891, { prod_id: this.prodId }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_productmovechoices_grid')
                .setLoadDataFunction({
                    method: 2892,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
}
